import StyledListWithCtaBox from "./StyledListWithCtaBox";

export default StyledListWithCtaBox;
